// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"352":"lang-vi-setting","729":"lang-en-US-setting","782":"lang-en-US","899":"lang-vi"}[chunkId] || chunkId) + "-legacy." + {"352":"23ab0aa1","505":"7aff0aaa","690":"2488b7f3","729":"ad4b0824","782":"b24a0b2a","899":"cd888bf8"}[chunkId] + ".js";
};